import React from "react";

const CustomTable = ({
  headers = [],
  data = [],
  rowKey = "_id",
  renderCell,
  actionMenu,
  classThead,
}) => {
  return (
    <table className="invoice-table">
      <thead className={classThead}>
        <tr>
          {headers.map((header, idx) => (
            <th key={idx}>{header.label}</th>
          ))}
          {actionMenu && <th aria-haspopup="menu">Actions</th>}
        </tr>
      </thead>

      <tbody>
        {data.length > 0 ? (
          data.map((row, rowIndex) => (
            <tr key={row[rowKey] || rowIndex}>
              {headers.map((header, colIndex) => (
                <td key={colIndex}>
                  {renderCell
                    ? renderCell(header.key, row)
                    : row[header.key] || "-"}
                </td>
              ))}
              {actionMenu && (
                <td>
                  {actionMenu(row)} {/* Génère les actions spécifiques */}
                </td>
              )}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={headers.length + (actionMenu ? 1 : 0)}>
              Aucun résultat trouvé.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default CustomTable;
